import { render, staticRenderFns } from "./Adset.vue?vue&type=template&id=47a5fdbc"
import script from "./Adset.vue?vue&type=script&lang=ts"
export * from "./Adset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports